import { FC } from 'react';

import { Text } from '@/components/typographies';
import { COLORS } from '@/styles/colors';

import * as styles from './styles';

interface OnTreatmentStatusProps {
  onTreatment?: boolean;
}

const OnTreatmentStatus: FC<OnTreatmentStatusProps> = (props) => {
  const { onTreatment } = props;

  return (
    <div className={styles.container(onTreatment)}>
      {onTreatment ? (
        <Text type={'caption_700'} color={COLORS.GREEN_80}>
          {'진료중'}
        </Text>
      ) : (
        <Text type={'caption_700'} color={COLORS.GRAY_70}>
          {'부재중'}
        </Text>
      )}
    </div>
  );
};

export default OnTreatmentStatus;
